import { Component, ViewEncapsulation } from '@angular/core';
import { TicketService } from 'src/app/services/ticket.service';
declare var $: any;

@Component({
  selector: 'app-fast-ticket-validation',
  templateUrl: './fast-ticket-validation.component.html',
  styleUrls: ['./fast-ticket-validation.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class FastTicketValidationComponent {
  fastTicketId: string;

  constructor(
    private ticketService: TicketService) {

  }

  public getFastTicket() {
    if (!this.fastTicketId || this.fastTicketId.length < 1) {
      return;
    }
    this.ticketService.getFastTicket(this.fastTicketId);
  }

}
